import React from 'react'
import classNames from 'classnames'

type Props = {
  small?: boolean
}

const Loading: React.FC<Props> = ({ small = false }) => (
  <div
    className={classNames('load-wrap', {
      'load-wrap--small': small,
    })}
  >
    <div className="circle"></div>
    <div className="circle"></div>
    <div className="circle"></div>
    <div className="circle"></div>
  </div>
)

export default Loading
